import { render, staticRenderFns } from "./ChatCard.vue?vue&type=template&id=ef3f55fc&"
import script from "./ChatCard.vue?vue&type=script&lang=js&"
export * from "./ChatCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports